export default __webpack_public_path__ + "static/media/logo-ilhabela.b95b9025.png";